"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TooltipPlacement = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _constants = require("../../components/constants");
var _PortalBase = _interopRequireDefault(require("../../components/PortalBase"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _environmentCharacteristics = require("../../utils/environmentCharacteristics");
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _placementUtils = require("../../utils/placementUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
/**
 * @deprecated use 'Placement' type instead.
 */
var TooltipPlacement = exports.TooltipPlacement = /*#__PURE__*/function (TooltipPlacement) {
  TooltipPlacement["BOTTOM"] = "bottom";
  TooltipPlacement["LEFT"] = "left";
  TooltipPlacement["RIGHT"] = "right";
  TooltipPlacement["TOP"] = "top";
  return TooltipPlacement;
}({});
var isInRootDocument = function isInRootDocument(element) {
  return _environmentCharacteristics.isBrowser ? element.ownerDocument.documentElement === window.document.documentElement : false;
};
var TooltipEl = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
    ref: ref
  }));
});
TooltipEl.displayName = "TooltipEl";
var Tooltip = function Tooltip(props) {
  var viewportEdgeOffset = 5;
  var children = props.children,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    className = props.className,
    title = props.title,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? "top" : _props$placement,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 12 : _props$offset,
    _props$container = props.container,
    container = _props$container === void 0 ? _environmentCharacteristics.isBrowser ? document.body : undefined : _props$container;
  var theme = (0, _reactJss.useTheme)();
  var flowPlacement = (0, _placementUtils.placementDirection)(placement, theme.direction);
  var classes = useStyles();

  // eslint-disable-next-line @atg/css-rtl-support
  var resetPosition = {
    top: "-100px",
    left: "-100px"
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var hasContent = !!title || false;
  var _useState3 = (0, _react.useState)(resetPosition),
    _useState4 = _slicedToArray(_useState3, 2),
    screenPosition = _useState4[0],
    setScreenPosition = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    shouldRenderTooltip = _useState6[0],
    setShouldRenderTooltip = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    tooltipRef = _useState8[0],
    setTooltipRef = _useState8[1];
  (0, _react.useEffect)(function () {
    setShouldRenderTooltip(true);
    if (!tooltipRef || !tooltipRef.current) {
      setTooltipRef(/*#__PURE__*/(0, _react.createRef)());
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var classesToApply = (0, _classnames.default)(classes.tooltip, overrides ? overrides.tooltip : null, className, _defineProperty({}, classes.visible, isVisible));
  var setInvisible = function setInvisible() {
    return setIsVisible(false);
  };
  var applyViewportOffset = function applyViewportOffset(lowerBound, value, upperBound) {
    return value < lowerBound ? lowerBound + viewportEdgeOffset : value > upperBound ? upperBound - viewportEdgeOffset : value;
  };
  var insideViewport = function insideViewport(coordinates, tooltipRect) {
    if (!_environmentCharacteristics.isBrowser) {
      return {
        y: 0,
        x: 0
      };
    }
    var _window = window,
      scrollY = _window.scrollY,
      scrollX = _window.scrollX;
    var viewportWidth = document.documentElement.clientWidth;
    var upperXBound = viewportWidth + scrollX - tooltipRect.width;
    var upperYBound = document.documentElement.clientHeight + scrollY - tooltipRect.height;

    // if tooltip is width of viewport, don't do offset
    if (tooltipRect.width >= viewportWidth) {
      return {
        y: applyViewportOffset(scrollY, coordinates.y, upperYBound),
        x: scrollX
      };
    }
    return {
      y: applyViewportOffset(scrollY, coordinates.y, upperYBound),
      x: applyViewportOffset(scrollX, coordinates.x, upperXBound)
    };
  };
  var getPosition = function getPosition(targetRect) {
    if (!tooltipRef || !tooltipRef.current) {
      return resetPosition;
    }
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    var windowScrollOffsetY = isInRootDocument(container) ? window.scrollY : 0;
    var windowScrollOffsetX = isInRootDocument(container) ? window.scrollX : 0;
    var middleY = targetRect.top + targetRect.height / 2 - tooltipRect.height / 2 + windowScrollOffsetY;
    var middleX = targetRect.left + targetRect.width / 2 - tooltipRect.width / 2 + windowScrollOffsetX;
    var bottom = targetRect.bottom + offset + windowScrollOffsetY;
    var top = targetRect.top + windowScrollOffsetY - (tooltipRect.height + offset);
    var right = targetRect.right + offset;
    var left = targetRect.left - tooltipRect.width - offset;
    var y = flowPlacement === "top" ? top : flowPlacement === "bottom" ? bottom : middleY;
    var x = flowPlacement === "left" ? left : flowPlacement === "right" ? right : middleX;
    var finalCoordinates = insideViewport({
      x: x,
      y: y
    }, tooltipRect);
    return {
      top: "".concat(finalCoordinates.y, "px"),
      // eslint-disable-next-line @atg/css-rtl-support
      left: "".concat(finalCoordinates.x, "px")
    };
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    var _event$currentTarget$;
    if ((_event$currentTarget$ = event.currentTarget.querySelector("input")) !== null && _event$currentTarget$ !== void 0 && _event$currentTarget$.disabled) {
      return;
    }
    if (hasContent) {
      // use event to find target
      var rect = event.currentTarget.getBoundingClientRect();
      var position = getPosition(rect);
      setScreenPosition(position);
      setIsVisible(true);
    }
  };
  var childrenWithListeners = /*#__PURE__*/(0, _react.cloneElement)(children, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: setInvisible,
    onBlur: setInvisible
  });
  var onTransitionEnd = function onTransitionEnd() {
    if (!isVisible) {
      setScreenPosition(resetPosition);
    }
  };
  var styles = _objectSpread({}, screenPosition);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, shouldRenderTooltip && /*#__PURE__*/_react.default.createElement(_PortalBase.default, {
    container: container
  }, hasContent ? /*#__PURE__*/_react.default.createElement(TooltipEl, {
    className: classesToApply,
    style: styles,
    onTransitionEnd: onTransitionEnd,
    ref: tooltipRef
  }, title) : /*#__PURE__*/_react.default.createElement("div", null)), childrenWithListeners);
};
var styles = function styles(theme) {
  return {
    tooltip: {
      display: "block",
      opacity: 0,
      zIndex: 0,
      background: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.8),
      color: theme.colors.textOnDark,
      fontSize: theme.typography.fontSize - 2,
      fontFamily: theme.typography.fontFamily,
      padding: "".concat(theme.spacing.base / 2, "px ").concat(theme.spacing.base, "px"),
      lineHeight: "1.4em",
      position: "absolute",
      transition: "opacity 300ms",
      borderRadius: 0,
      textAlign: "center",
      pointerEvents: "none",
      maxWidth: "100vw"
    },
    visible: {
      opacity: 1,
      zIndex: _constants.Z_INDEX.Tooltip
    },
    hidden: {
      display: "none"
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "Tooltip"
});
Tooltip.displayName = "Tooltip";
var Storybook = exports.Storybook = Tooltip;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/information-tooltip--docs
 */

var exportedComponent = (0, _defaultProps.default)(Tooltip);
exportedComponent.displayName = "Tooltip";
var _default = exports.default = exportedComponent;